// <div data-controller="automated-emails--form">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";
import * as helpers from "@/utils/helpers";
import { createFlash } from "@/utils/flash";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [ "deliveryDaysCheckBox" ];
  static classes = [ "" ];
  static outlets = [];
  static values = {};

  initialize() {

  }

  validateDeliveryDays(e) {
    const allUnchecked = this.deliveryDaysCheckBoxTargets.every((target) => !target.checked);

    if (allUnchecked) {
      createFlash({
        key: "error",
        ttl: 10,
        message: "최소 하루 이상의 발송 가능 요일 선택이 필요합니다"
      });

      e.preventDefault();
    }
  }

  connect() {

  }

  disconnect() {

  }
}